import {
  ADDNEWWALLETFORCUSTOLIST_SUCCESS,
  ADDNEWWALLETFORCUSTOLIST_FAILED,
  RESET_ADDNEWWALLETFORCUSTOLIST,
  LOADING_ADDNEWWALLETFORCUSTOLIST,
  NETWORK_ERROR_ADDNEWWALLETFORCUSTOLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddNewWalletForCustomerList = () => {
  return { type: RESET_ADDNEWWALLETFORCUSTOLIST };
};

const addNewWalletForCustomerList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDNEWWALLETFORCUSTOLIST });
    await partnerServices
      .post("addNewWalletForCustomer", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(addNewWalletForCustomerListSuccess(res.data));
            break;
          default:
            dispatch(addNewWalletForCustomerListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_ADDNEWWALLETFORCUSTOLIST,
          payload: err,
        });
      });
  };
function addNewWalletForCustomerListSuccess(data) {
  return {
    type: ADDNEWWALLETFORCUSTOLIST_SUCCESS,
    payload: data,
  };
}
function addNewWalletForCustomerListFailed(data) {
  return {
    type: ADDNEWWALLETFORCUSTOLIST_FAILED,
    payload: data,
  };
}

export { resetAddNewWalletForCustomerList, addNewWalletForCustomerList };
